function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0.00585938L27.3167 2.45893V13.7335C27.3167 20.5704 24.027 25.1367 20.7595 27.9742C19.1289 29.3903 17.5004 30.38 16.2795 31.0162C15.6684 31.3346 15.1575 31.5654 14.7969 31.7175C14.6165 31.7936 14.4736 31.8501 14.3743 31.888C14.3246 31.907 14.2859 31.9213 14.2588 31.9312L14.227 31.9426L14.2179 31.9459L14.214 31.9472C14.2136 31.9474 14.2133 31.9475 14 31.3335C13.781 31.9455 13.7807 31.9453 13.7803 31.9452L13.7793 31.9449L13.7765 31.9438L13.7674 31.9405L13.7357 31.9288C13.7087 31.9186 13.67 31.9039 13.6204 31.8845C13.5212 31.8456 13.3784 31.7877 13.1982 31.7099C12.8378 31.5544 12.3273 31.3189 11.7165 30.9953C10.4964 30.3489 8.8688 29.3469 7.23902 27.923C3.97446 25.0708 0.68335 20.5052 0.68335 13.7335V2.45893L14 0.00585938ZM14 31.3335L13.7803 31.9452L13.9968 32.0227L14.214 31.9472L14 31.3335ZM14.0031 30.6376C14.0805 30.6071 14.1774 30.5679 14.2917 30.5197C14.6237 30.3796 15.1024 30.1636 15.6788 29.8633C16.8329 29.2619 18.3711 28.3266 19.9072 26.9927C22.9731 24.3302 26.0167 20.0965 26.0167 13.7335V3.54133L14 1.32773L1.98335 3.54133V13.7335C1.98335 20.0284 5.02557 24.2628 8.09435 26.944C9.63123 28.2867 11.1703 29.2347 12.3252 29.8466C12.9019 30.1522 13.3809 30.3729 13.7133 30.5164C13.8282 30.5659 13.9255 30.6062 14.0031 30.6376Z",
  fill: "#2F7067"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.8962 8.72522L14.0034 20.6634L7.87097 14.4571L8.7957 13.5433L13.7299 18.5371L19.7704 8.0752L20.8962 8.72522Z",
  fill: "#2F7067"
});

var SvgGuard = function SvgGuard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guard.277b12fc.svg";
export { ForwardRef as ReactComponent };